import { styledComponent, Accordion } from '@hermes/web-components'

export const AccordionOverride = styledComponent(Accordion)({
  '&.MuiPaper-root': {
    margin: 0,
    border: 'solid #EAEEFC 2px',

    '&:not(:last-of-type)': {
      borderBottom: 'none'
    },

    '&:not(:first-of-type)': {
      borderTop: 'solid #EAEEFC 1px'
    },

    '& [aria-expanded="false"]': {
      background: 'transparent',
      border: 'none'
    },

    '& [aria-expanded="true"]': {
      background: '#F4F7FD',
      fontWeight: '500'
    },

    '&:first-of-type': {
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      '& .MuiButtonBase-root': {
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px'
      },
      '& .MuiAccordion-heading': {
        '& .MuiAccordionSummary-root': {
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px'
        }
      }
    },

    '&:last-of-type': {
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '16px',
      '& .MuiAccordion-heading': {
        '& .MuiAccordionSummary-root': {
          borderBottomLeftRadius: '16px',
          borderBottomRightRadius: '16px'
        }
      }
    }
  },

  '& .MuiAccordionSummary-content': {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0
    }
  },
  '& .MuiAccordionSummary-root': {
    height: 'auto',
    padding: '12px 16px',

    '&.Mui-expanded': {
      height: 'auto'
    }
  },
  '& .MuiAccordionDetails-root': {
    padding: '16px'
  }
})
